module.exports = __webpack_public_path__ + "static/sca-loader-06dcffec7a95d5867261de2f80b77a5b.jpg";